import { studentDeleteApi } from "../../api/student/studentDeleteApi"

type PayloadShape = Parameters<typeof studentDeleteApi>[0]

export async function studentDeleteService(payload: PayloadShape, token: string) {
	return await studentDeleteApi(payload, token)
}
